import { css, cx } from 'linaria';
import { breakpointLargeTablet } from 'common/constants';
import { FilterMenu } from 'components/list-filter-menu/list-filter-menu';
import { useTranslation } from 'next-i18next';
import { Loader } from 'components/loader/loader';
import { ListSort } from 'components/list-sort/list-sort';
import { myListHeaderStyle } from './my-list-header';
const searchStyles = "suns7i2";
export const SearchPageHeader = ({
  filter,
  total,
  query,
  sortOrder,
  isPremium,
  handleNewest,
  handleOldest,
  handleRelevance
}) => {
  const {
    t
  } = useTranslation();
  const isLoading = total === false;
  return query ? <header className={cx(myListHeaderStyle, searchStyles)}>
      <h1 className="pageTitle" data-cy="page-title">
        <em data-cy="search-query">"{query}"</em> —{' '}
        {isLoading ? <span>
            {t('search:searching', 'Searching')} <Loader />{' '}
          </span> : <span>
            {total || 0} {t('search:search-results', 'Search Results')}
          </span>}
      </h1>
      <FilterMenu subset="search" query={query} filter={filter} />
      <ListSort sortOrder={sortOrder} showRelevance={isPremium} handleNewest={handleNewest} handleOldest={handleOldest} handleRelevance={handleRelevance} />
    </header> : null;
};

require("./search-page-header.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./search-page-header.js");